<template>
  <div class="d-flex flex-wrap">
    <div v-if="type === 'fund-history'" class="transac-cash-register-section">
      <b-button
          v-if="$can('make_deposits', 'Caisse Générale')"
          variant="success"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          @click="toggleModal('credit')"
      >
        Entrée
      </b-button>
      <b-button
          v-if="
        $can('make_withdraws', 'Caisse Générale') ||
        $can('add_request_from_fund_hystory', 'Caisse Générale') ||
        $can('add_project_request_from_fund_hystory', 'Caisse Générale')
      "
          variant="outline-danger"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="ml-1"
          @click="toggleModal('debit')"
      >
        Sortie
      </b-button>
    </div>
    <div v-if="type === 'dedicated-fund' && $can('make_fund_transfer', 'Fond Dédié')"
         class="transac-dedicated-fund-section">
      <b-button
          variant="primary"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          @click="toggleModal('transfer')"
      >
        Transfert
        <feather-icon icon="ArrowRightIcon" class="ml-50"/>
      </b-button>
    </div>

    <!-- Add New Transac Modal -->
    <component
        :is="currentModalComponent"
        ref="transacModal"
        :concernedRegisterType.sync="registerType"
        :showContent.sync="openModal"
        :loading.sync="isLoading"
        @addTransac="addTransac"
    />
  </div>
</template>

<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {BButton, VBToggle} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import FormDebitHandler from "./transac/DebitHandler.vue";
import FormCreditHandler from "./transac/CreditHandler.vue";
import CashRegisterDetailsModalProvidingForm
  from "@/views/apps/dedicated-fund/dedicated-fund-list/cash-register/cash-register-details-modal/CashRegisterDetailsModalProvidingForm.vue";

export default {
  name: "TransacModal",
  components: {
    BButton,
    FormDebitHandler,
    FormCreditHandler,
    CashRegisterDetailsModalProvidingForm,
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  props: {
    type: {
      type: String,
      default: "fund-history",
    },
  },
  data() {
    return {
      isLoading: false,
      openModal: false,
      transactTypeClick: "",
      registerType: "cash-register",
    };
  },
  computed: {
    currentModalComponent() {
      return this.transactTypeClick;
    },
    getErrors() {
      return this.$store.getters["fundHistory/errors"];
    }
  },
  methods: {
    toggleModal(option) {
      if (option == "credit") {
        this.transactTypeClick = "form-credit-handler";
      } else if (option == "debit") {
        this.transactTypeClick = "form-debit-handler";
      } else if (option == "transfer") {
        this.transactTypeClick = "cash-register-details-modal-providing-form";
      }
      this.openModal = true;
    },
    showToast(message, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: icon,
          variant: variant,
        },
      });
    },
    // send transact request to the API
    async addTransac(data) {
      try {
        const {message} = this.registerType ? await this.addFundHistory(data) : await this.makeTransfer(data);
        this.handleSuccess(message);
      } catch (e) {
        this.showToast(
            this.getErrors.message ? this.getErrors.message : "Erreur lors de l'enregistrement",
            "CoffeeIcon",
            "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async addFundHistory(payload) {
      return await store.dispatch("fundHistory/addFundHistory", payload)
    },
    async makeTransfer(payload) {
      return await store.dispatch("dedicatedFund/makeTransfer", payload)
    },
    handleSuccess(message) {
      this.$emit("transacUpdated");
      this.showToast(message, "CheckIcon", "success");
      if (this.$refs.transacModal && this.$refs.transacModal.resetModal) {
        this.$refs.transacModal.resetModal();
      }
      this.openModal = false;
    },
  },
};
</script>
